import { Box, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";
import { useHistory } from "react-router";

import { buildDiagnosisFlowSteps } from "@/components/diagnosis/diagnosisFlowStepDefinitions";
import DiagnosisFlowSteps from "@/components/diagnosis/DiagnosisFlowSteps";
import { RegistrationFlowLayout, RegistrationActions } from "@/layouts/RegistrationFlowLayout";
import theme from "@/theme";

import CharacterImage from "@assets/image/registration_complete_character.png";

// 投資力診断は完了(✓)、残り2段階はこれから。文言は4画面共通の定義（diagnosisFlowStepDefinitions）を使う
const COMPLETE_STEPS = buildDiagnosisFlowSteps(["completed", "upcoming", "upcoming"]);

const useStyles = makeStyles(() => ({
  heading: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.4,
    textAlign: "center",
    whiteSpace: "pre-line",
    color: theme.palette.text.primary,
  },
  characterWrap: {
    display: "flex",
    justifyContent: "center",
    margin: theme.spacing(0, 0, 3),
  },
  characterImage: {
    width: "100%",
    maxWidth: 269,
    height: "auto",
    display: "block",
    margin: "0 auto",
  },
}));

export const RegistrationCompletePage: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();

  const onClickShowResult = React.useCallback(() => {
    history.push("/diagnosis");
  }, [history]);

  return (
    <RegistrationFlowLayout hero>
      <Box className={classes.characterWrap}>
        <img src={CharacterImage} alt="登録完了" className={classes.characterImage} />
      </Box>
      <Typography className={classes.heading}>登録が完了しました！</Typography>
      <Box mt={3}>
        <DiagnosisFlowSteps steps={COMPLETE_STEPS} animateCompletion />
      </Box>
      <RegistrationActions onNext={onClickShowResult} tone="trust" label="投資力診断結果を見る" />
    </RegistrationFlowLayout>
  );
};
